import React from 'react';

import styles from './GroupPending.module.scss'
import {Avatar} from "antd";
import {useTranslation} from "react-i18next";
import {formatDate} from "../../../utils/date.utils";
import CenterButton from "../../shared/button/CenterButton";

interface GroupPendingProps {
    id: string
    imgURL: string
    name: string
    date: any
    declineLabel?: string
    acceptLabel?: string
    disabledAccept?: boolean
    onDecline: (id: string) => void
    onAccept: (id: string) => void
}

export const GroupPending: React.FunctionComponent<GroupPendingProps> = (props) => {
    const { t } = useTranslation();
    return (
        <div className={styles.PendingContainer}>
            <div>
                <Avatar src={props.imgURL} size={48}/>
            </div>
            <div className={styles.PendingDetailContainer}>
                <div className={styles.GroupDetailCon}>
                    <span style={{fontWeight: "bold"}}>{props.name}</span>
                    <span className={styles.Date}>{formatDate(props.date)}</span>
                </div>
                <div className={styles.BtnCon}>
                    <CenterButton
                        ghost
                        onClick={() => {
                            props.onDecline(props.id);
                        }}
                        small
                        style={{marginRight: ".5rem"}}
                    >
                        {props.declineLabel ? props.declineLabel : t("Decline")}
                    </CenterButton>
                    <CenterButton
                        small
                        onClick={() => {
                            props.onAccept(props.id);
                        }}
                        disabled={props.disabledAccept}
                    >
                        {props.acceptLabel ? props.acceptLabel : t("Accept")}
                    </CenterButton>
                </div>
            </div>
        </div>
    )
}